var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2756 0.198915L13.5648 5.90114L19.7636 7.35985C20.0167 7.42615 20.0799 7.75768 19.8902 7.95659L15.7787 12.9958L16.2847 19.6263C16.348 19.8915 16.0317 20.0904 15.8419 19.9578L10.0226 17.3719L4.14007 19.9578C3.95031 20.0241 3.6973 19.8252 3.6973 19.6263L4.26658 12.9958L0.0918542 7.95659C-0.0979058 7.75768 0.0286009 7.42615 0.281614 7.35985L6.41719 5.90114L9.70636 0.198915C9.83287 -0.066305 10.1491 -0.066305 10.2756 0.198915Z",
    fill: "#FEC802"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star_filled.6cce965ee2fc6de46ac3b8673ced3d03.svg";
export { ForwardRef as ReactComponent };